import { Localization } from "../../../common/localizable-component";
import { PaginationLocalization } from "./pagination-types";

export const PAGINATION_LOCALIZATION: Localization<PaginationLocalization> = {
  en: {
    itemsPerPage: "Items per page:",
    of: "of",
    items: "items",
    previous: "Previous page",
    next: "Next page",
    currentPage: "Current page:",
    paginationAddedInfo: "pages. Press enter to go to the specified page directly."
  },
  de: {
    itemsPerPage: "Elemente pro Seite:",
    of: "von",
    items: "Elementen",
    previous: "Vorherige Seite",
    next: "Nächste Seite",
    currentPage: "Aktuelle Seite:",
    paginationAddedInfo: "Seiten. Drücken Sie die Eingabetaste, um direkt zur angegebenen Seite zu gelangen."
  },
  sv: {
    itemsPerPage: "Träffar per sida:",
    of: "av",
    items: "träffar",
    previous: "Föregående sida",
    next: "Nästa sida",
    currentPage: "Nuvarande sida:",
    paginationAddedInfo: "sidor. Tryck på Enter för att gå direkt till den angivna sidan."
  },
  nl: {
    itemsPerPage: "Artikelen per pagina:",
    of: "van",
    items: "items",
    previous: "Vorige pagina",
    next: "Volgende pagina",
    currentPage: "Huidige pagina:",
    paginationAddedInfo: "pagina's. Druk op Enter om direct naar de opgegeven pagina te gaan."
  },
  it: {
    itemsPerPage: "Elementi per pagina:",
    of: "di",
    items: "elementi",
    previous: "Pagina precedente",
    next: "Pagina successiva",
    currentPage: "Pagina attuale:",
    paginationAddedInfo: "pagine. Premi Invio per andare direttamente alla pagina specificata."
  },
  hu: {
    itemsPerPage: "Tételek oldalanként:",
    of: "a",
    items: "Tételek",
    previous: "Előző oldal",
    next: "Következő oldal",
    currentPage: "Aktuális oldal:",
    paginationAddedInfo: "oldal. Nyomja meg az Enter billentyűt az adott oldalra történő közvetlen eljutáshoz."
  },
  da: {
    itemsPerPage: "Varer per side:",
    of: "af",
    items: "varer",
    previous: "Forrige side",
    next: "Næste side",
    currentPage: "Nuværende side:",
    paginationAddedInfo: "sider. Tryk på Enter for at gå direkte til den angivne side."
  },
  fr: {
    itemsPerPage: "Éléments par page:",
    of: "de",
    items: "éléments",
    previous: "Page précédente",
    next: "Page suivante",
    currentPage: "Page actuelle:",
    paginationAddedInfo: "pages. Appuyez sur Entrée pour accéder directement à la page spécifiée."
  },
  es: {
    itemsPerPage: "Artículos por página:",
    of: "de",
    items: "elementos",
    previous: "Pagina anterior",
    next: "Siguiente página",
    currentPage: "Página actual:",
    paginationAddedInfo: "páginas. Presiona Enter para ir directamente a la página especificada."
  },
  pl: {
    itemsPerPage: "Pozycje na stronie:",
    of: "z",
    items: "pozycje",
    previous: "Poprzednia strona",
    next: "Następna strona",
    currentPage: "Bieżąca strona:",
    paginationAddedInfo: "stron. Naciśnij Enter, aby przejść bezpośrednio do określonej strony."
  },
  ro: {
    itemsPerPage: "Elemente per pagină:",
    of: "de",
    items: "elemente",
    previous: "Pagina anterioară",
    next: "Pagina următoare",
    currentPage: "Pagina curentă:",
    paginationAddedInfo: "pagini. Apăsați Enter pentru a merge direct la pagina specificată."
  },
  hr: {
    itemsPerPage: "stavke po stranici:",
    of: "od",
    items: "stavke",
    previous: "Prethodna stranica",
    next: "Sljedeća stranica",
    currentPage: "Trenutna stranica:",
    paginationAddedInfo: "stranica. Pritisnite Enter za izravni prijelaz na određenu stranicu."
  },
  cs: {
    itemsPerPage: "Položky na stránku:",
    of: "z",
    items: "položky",
    previous: "Předchozí stránka",
    next: "Další strana",
    currentPage: "Aktuální stránka:",
    paginationAddedInfo: "stránek. Stiskněte Enter pro přechod přímo na určenou stránku."
  },
  sl: {
    itemsPerPage: "Elementi na stran:",
    of: "na",
    items: "Elementi",
    previous: "Prejšnja stran",
    next: "Naslednja stran",
    currentPage: "Trenutna stran:",
    paginationAddedInfo: "strani. Pritisnite Enter za neposreden prehod na določeno stran."
  }
};
